import { useTranslation } from "react-i18next";
import { useRtdbValue } from "../firebase/listeners.js";

interface LogEntry {
  ts: number;
  uid: string;
  kind: string;
  payload?: Record<string, unknown>;
}

export default function LogFeed({ tableId }: { tableId: string }) {
  const { t } = useTranslation();
  const { data, loading } = useRtdbValue<Record<string, LogEntry>>(`tables/${tableId}/log`);
  if (loading) return <p className="text-sm text-muted-foreground">{t("app.loading")}</p>;
  if (!data) return <p className="text-sm text-muted-foreground">no entries yet</p>;
  const entries = Object.entries(data).sort(([, a], [, b]) => a.ts - b.ts);
  return (
    <ul className="space-y-1 text-sm">
      {entries.map(([id, e]) => (
        <li key={id} className="rounded border border-border px-2 py-1">
          <span className="font-mono text-xs text-muted-foreground">{e.kind}</span>{" "}
          <span className="text-foreground">{renderPayload(e)}</span>
        </li>
      ))}
    </ul>
  );
}

function renderPayload(e: LogEntry): string {
  if (e.kind === "roll") {
    const p = e.payload as { skillId?: string; total?: number; outcome?: string };
    return `${p.skillId ?? "?"} → ${p.total ?? "?"} (${p.outcome ?? "?"})`;
  }
  if (e.kind === "compel-offered") {
    const p = e.payload as { aspectId?: string };
    return `compel: ${p.aspectId ?? "?"}`;
  }
  return JSON.stringify(e.payload ?? {});
}
